import { Building2 } from 'lucide-react';
import { ContextHero, EmptyStateModern, PageContainer } from '@/components/design-system';

export function B2cInterTab(): JSX.Element {
  return (
    <PageContainer>
      <div className="space-y-6">
        <ContextHero
          variant="formation_b2c"
          icon={<Building2 className="h-5 w-5" />}
          title="Sessions Inter B2C"
          subtitle="Journées combinant plusieurs formations B2C en un même lieu (ex : journée Bien-être : coiffure + esthétique + cake design)."
        />
        <EmptyStateModern
          variant="formation_b2c"
          icon={<Building2 className="h-7 w-7" />}
          title="Sessions Inter B2C"
          description="Le module sessions combinées arrive Sprint 6.6 — pour l'instant, créez des actions B2C indépendantes dans l'onglet Sessions."
        />
      </div>
    </PageContainer>
  );
}
